<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import { WorkCalendar } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import WorkCalendarForm from './WorkCalendarForm.vue';
    import QueryKey from '@/enums/QueryKey';

    const form = useForm({
        name: '',
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.salary.work-calendars.store')"
        :query-key="[QueryKey.WORK_CALENDARS]"
        title="work-calendars.create"
        button-text="work-calendars.create"
    >
        <WorkCalendarForm :form="form" />
    </DialogForm>
</template>
